import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForExploreEditionBenefitsModalWithPDE({
	product,
	edition,
	isInTrial,
	invoiceableStatus,
	hasPaymentDetailsEntered,
}: EditionAwarenessContextType): boolean {
	if (
		edition === 'standard' &&
		isInTrial &&
		isProductOneOf(product, ['jira-service-management', 'jira-customer-service']) &&
		(hasPaymentDetailsEntered || invoiceableStatus === 'INVOICEABLE')
	) {
		return true;
	}

	return false;
}
